import type {
  KeyAccount,
  KeyAccountApi,
  KeyAccountAddRequestData,
  KeyAccountTrackingResponse,
  KeyAccountTrackingResponseApi,
  KeyAccountTracking,
  KeyAccountTrackingApi,
  KeyAccountsResponseDataApi,
  KeyAccountsResponseData,
  KeyAccountResponseDataApi,
  KeyAccountResponseData
} from './types'
import { formatCnpj } from 'commons/utils/string'
import { formatDate } from 'commons/utils/date'

export const toKeyAccount = (keyAccountApi: KeyAccountApi): KeyAccount => {
  return {
    id: keyAccountApi.codigo,
    name: keyAccountApi.nome,
    cnpj: keyAccountApi.cnpj,
    cnpjFormatted: formatCnpj(keyAccountApi.cnpj)
  }
}

export const toKeyAccountResponseData = (
  response: KeyAccountResponseDataApi
): KeyAccountResponseData => {
  const { data } = response

  return {
    data: toKeyAccount(data)
  }
}

export const toKeyAccountsResponseData = (
  response: KeyAccountsResponseDataApi
): KeyAccountsResponseData => {
  const { data } = response

  const keyAccounts = data.map((keyAccount) => {
    return toKeyAccount(keyAccount)
  })

  return {
    data: keyAccounts
  }
}

export const toKeyAccountAddRequestData = (id: string): KeyAccountAddRequestData => {
  return {
    codigo: id
  }
}

export const toKeyAccountTracking = (
  keyAccountApi: KeyAccountTrackingApi
): KeyAccountTracking => {
  return {
    id: keyAccountApi.codigo,
    idSapCustomer: keyAccountApi.codigoSap,
    name: keyAccountApi.nomeCliente,
    cnpj: keyAccountApi.cnpj,
    cnpjFormatted: formatCnpj(keyAccountApi.cnpj),
    action: keyAccountApi.acao,
    date: keyAccountApi.data,
    dateFormatted: formatDate(keyAccountApi.data, 'DD/MM/YYYY'),
    timeFormatted: formatDate(keyAccountApi.data, 'HH:mm'),
    user: keyAccountApi.usuario
  }
}

export const toKeyAccountTrackingResponse = (
  response: KeyAccountTrackingResponseApi
): KeyAccountTrackingResponse => {
  const { data, pagination } = response

  const keyAccountsTracking = data.map((keyAccountTrackingApi) => {
    return toKeyAccountTracking(keyAccountTrackingApi)
  })

  return {
    pagination,
    data: keyAccountsTracking
  }
}
